document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.splide')) {
        return;
    }

    const startIndex = parseInt(document.querySelector('.js-splide-active-index').getAttribute('data-active-index'));
    const splide = new Splide('.splide', {
        perPage: 12,
        start: startIndex,
        drag: false,
        arrows: false, // we build our own custom arrows
        breakpoints: {
            800: {
                perPage: 4,
            },
            1000: {
                perPage: 8,
            },
        },
    });

    const prevBtn = document.querySelector('.query-loop-slide-arrow--prev');
    const nextBtn = document.querySelector('.query-loop-slide-arrow--next');
    prevBtn.addEventListener('click', () => splide.go('<'));
    nextBtn.addEventListener('click', () => splide.go('>'));

    splide.on('move', index => {
        toggleButtons(index);
    });

    splide.on('mounted', () => {
        // Ensure the correct buttons are shown on initial mount
        toggleButtons(startIndex);
    });

    splide.mount();

    function toggleButtons(index) {
        if (splide.options.perPage > splide.length) {
            prevBtn.classList.add('hidden');
            nextBtn.classList.add('hidden');
            return;
        }

        // hide prev if on first slide
        if (index == 0) {
            prevBtn.classList.add('hidden');
        } else {
            prevBtn.classList.remove('hidden');
        }

        // hide next if no more slides beyond what's shown
        if ((index + splide.options.perPage) > (splide.length - 1)) {
            nextBtn.classList.add('hidden');
        } else {
            nextBtn.classList.remove('hidden');
        }
    }
});
